import React from "react";
import Bharat24 from "../pictures/Bharat-24-Logo_G_Logo.png";
import UBF_img from "../pictures/UBF-Logo.png";
import xoomstudio from "../pictures/Xoom-Studio.jpg";
import FirstIndialogo from "../pictures/First-India-logo.jpeg";
import news10englishlogo from "../pictures/news10englishlogo.jpg";
import TheSMETimes from "../pictures/The-SME-Times.png";
import AajTak_Internationalremovebgpreview from "../pictures/AajTak_International-removebg-preview.png";
import ThePharmaTimes from  "../pictures/The-Pharma-Times.png";
import ThePowerTimes from "../pictures/The-Power-Times.png";
import TheProperty from "../pictures/The-Property-Times.png";
import cw_logo_img from "../pictures/CW-Logo-jp-1.jpg";
import india_chl_img from "../pictures/download__3_-removebg-preview-1.png";
import india_today_img from "../pictures/INDIA_TODAY_LOGO_for_Print_Approved-1.png";


const Our_partner = () =>
{   
    return(
        <>
          <div className="Our_partner_container">
            <div className="Our_logos_slider">
                <img src={Bharat24} alt="not"/>
                <img src={UBF_img} alt="not"/>
                <img src={xoomstudio} alt="not"/>
                <img src={FirstIndialogo} alt="not"/>
                <img src={news10englishlogo} alt="not"/>
                <img src={india_chl_img} alt="not"/>
                <img src={AajTak_Internationalremovebgpreview} alt="not"/>
                <img src={TheSMETimes} alt="not"/>
                <img src={ThePharmaTimes} alt="not"/>
                <img src={ThePowerTimes} alt="not"/>
                <img src={TheProperty} alt="not"/>
                <img src={india_today_img } alt="not"/>
                <img src={cw_logo_img} alt="not"/>
            </div>
            <div className="Our_logos_slider">
            <img src={Bharat24} alt="not"/>
                <img src={UBF_img} alt="not"/>
                <img src={xoomstudio} alt="not"/>
                <img src={FirstIndialogo} alt="not"/>
                <img src={news10englishlogo} alt="not"/>
                <img src={india_chl_img} alt="not"/>
                <img src={AajTak_Internationalremovebgpreview} alt="not"/>
                <img src={TheSMETimes} alt="not"/>
                <img src={ThePharmaTimes} alt="not"/>
                <img src={ThePowerTimes} alt="not"/>
                <img src={TheProperty} alt="not"/>
                <img src={india_today_img } alt="not"/>
                <img src={cw_logo_img} alt="not"/>
            </div>
          </div>
        </>
    )
}

export default Our_partner;

